import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import './IndividualAlbum.css';

export default function IndividualAlbum() {
    const { id } = useParams();
    const [album, setAlbum] = useState(null);
    const [loading, setLoading] = useState(true);
    const [fetchError, setFetchError] = useState('');

    useEffect(() => {
        fetchAlbum();
    }, [id]);

    const fetchAlbum = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/albums/${id}`,
                { withCredentials: true }
            );

            setAlbum(response.data.album);
            setFetchError('');
        } catch (err) {
            console.error('Error fetching album:', err);
            setFetchError('Kunne ikke laste album');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="alb-detail-loading">Laster album…</div>;
    }

    if (fetchError) {
        return <div className="alb-detail-error-page">{fetchError}</div>;
    }

    if (!album) {
        return <div className="alb-detail-error-page">Album ikke funnet</div>;
    }

    const isPublic = album.isPublic === 1 || album.isPublic === true;
    const activities = Array.isArray(album.activities) ? album.activities : [];

    return (
        <div className="alb-detail">
            <div className="alb-detail-container">
                <div className="alb-detail-top">
                    <Link to="/albums" className="alb-detail-back">
                        <i className="fas fa-arrow-left" aria-hidden="true" />
                        Tilbake til album
                    </Link>
                </div>

                <section className="alb-detail-hero">
                    <h1>{album.name}</h1>
                    {album.shortDescription && (
                        <p className="alb-detail-hero-lead">{album.shortDescription}</p>
                    )}
                    <div className="alb-detail-meta">
                        {isPublic ? (
                            <span className="alb-detail-pill alb-detail-pill--published">
                                <i className="fas fa-globe" aria-hidden="true" />
                                Publisert
                            </span>
                        ) : (
                            <span className="alb-detail-pill alb-detail-pill--draft">
                                <i className="fas fa-lock" aria-hidden="true" />
                                Utkast
                            </span>
                        )}
                        <span className="alb-detail-pill">
                            <i className="fas fa-list" aria-hidden="true" />
                            {activities.length} {activities.length === 1 ? 'aktivitet' : 'aktiviteter'}
                        </span>
                    </div>
                </section>

                {album.description && (
                    <section className="alb-detail-section">
                        <h2>Om albumet</h2>
                        <p className="alb-detail-desc">{album.description}</p>
                    </section>
                )}

                <section className="alb-detail-section">
                    <div className="alb-detail-activities-header">
                        <h2>Aktiviteter i dette albumet</h2>
                        <span className="alb-detail-count">
                            {activities.length} {activities.length === 1 ? 'aktivitet' : 'aktiviteter'}
                        </span>
                    </div>

                    {activities.length > 0 ? (
                        <div className="alb-detail-activities-grid">
                            {activities.map((activity) => {
                                const activityId = activity.idactivity || activity.id;
                                const isFree = activity.isFree === 1 || activity.isFree === true;

                                return (
                                    <Link
                                        key={activityId}
                                        to={`/activities/${activityId}`}
                                        className="alb-detail-activity-card"
                                    >
                                        <h3>{activity.name}</h3>
                                        {(activity.short_description || activity.shortDescription) && (
                                            <p className="alb-detail-activity-desc">
                                                {activity.short_description || activity.shortDescription}
                                            </p>
                                        )}
                                        <div className="alb-detail-activity-meta">
                                            <span className="alb-detail-activity-pill">
                                                <i className={`fas ${isFree ? 'fa-gift' : 'fa-star'}`} aria-hidden="true" />
                                                {isFree ? 'Gratis' : 'Premium'}
                                            </span>
                                            {activity.minutes && (
                                                <span className="alb-detail-activity-pill">
                                                    <i className="fas fa-clock" aria-hidden="true" />
                                                    {activity.minutes} min
                                                </span>
                                            )}
                                            {activity.level_name && (
                                                <span className="alb-detail-activity-pill">
                                                    <i className="fas fa-bolt" aria-hidden="true" />
                                                    {activity.level_name}
                                                </span>
                                            )}
                                            {activity.stepsName && (
                                                <span className="alb-detail-activity-pill">
                                                    <i className="fas fa-running" aria-hidden="true" />
                                                    {activity.stepsName}
                                                </span>
                                            )}
                                        </div>
                                        <span className="alb-detail-activity-cta">
                                            Se aktivitet
                                            <i className="fas fa-arrow-right" aria-hidden="true" />
                                        </span>
                                    </Link>
                                );
                            })}
                        </div>
                    ) : (
                        <p className="alb-detail-empty">Ingen aktiviteter i dette albumet ennå</p>
                    )}
                </section>
            </div>
        </div>
    );
}
